import {FC} from 'react';
import {PageSubtitleTextBlockWrapper} from '@molecules/PageSubtitleTextBlock.styles';
import Text from '@atoms/Text';
import {theme} from "@styles/theme";

export interface PageSubtitleTextBlockProps {
  title?: string;
  text?: string;
}

const PageSubtitleTextBlock: FC<PageSubtitleTextBlockProps> = ({title, text}) => {
  return (
    <PageSubtitleTextBlockWrapper>
      {title && <Text text={title} type="tinyR" color={theme.colors.basic02} />}
      {text && <Text text={text} type="tinyNum" />}
    </PageSubtitleTextBlockWrapper>
  );
};

export default PageSubtitleTextBlock;
